<template>
    <div>
        <v-row>
        <span class="title pa-2">Key Facts</span>
        <v-spacer/>
        <v-btn small width="180px" color="success" @click="AddFact()">
            Add New
        </v-btn>
        </v-row>
        <v-row v-for="(fact,index) in keyFacts" :key="index">
            <v-text-field label="Key" v-model="fact.key" hide-details="" outlined class="mr-2" v-on:change="OnChange()"/>
            <v-textarea
               label="Value"
               v-model="fact.value"
               hide-details
               outlined
               v-on:change="OnChange()"
            >
            </v-textarea>
            <v-col cols="1">
                <v-btn icon @click="RemoveAtIndex(index)">
                    <v-icon>
                        mdi-delete
                    </v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>

export default {
    
    name: "KeyFactsItems",
    components: {

    },
    computed : {



    },
    data() {
        return {

            keyFacts : []
        }
    },
    props: {
        //Content model to use for datatable content
        content: {
            default : null,
            type : Object
        },
        //Should this table NOT have an editable column
        readOnly: {
            default : true,
            type : Boolean
        }
    },
    mounted() {

        this.OnChange();

    },
    methods:{

        RemoveAtIndex(index)
        {
            this.keyFacts.splice(index,1)
            this.OnChange();
        },
        AddFact()
        {
            this.keyFacts;
            this.keyFacts.push({});
            this.OnChange();
        },
        OnChange()
        {
            var returnObj = {facts: this.keyFacts};
            this.$emit("OnChangeContent",returnObj);
            /*
            var columnsExport = this.columns.slice();
            columnsExport.pop();

            var itemsExport = new Array();

            for (let i = 0; i < this.items.length; i++) {
                var itemArray = new Array();
                for (let c = 0; c < columnsExport.length; c++) {
                    
                    var foundValue = this.items[i]["" + columnsExport[c].value];
                    if(foundValue != null)
                    {
                        itemArray.push("" + foundValue)
                    }
                    else
                    {
                        itemArray.push("");
                    }
                }
                itemsExport.push(itemArray);
            }

            var returnObj = {title : this.contentTitle,columns: columnsExport, rows: itemsExport};
            this.$emit("OnChangeContent",returnObj);
            */
        }

    },
    watch : {

        content :
        {
            immediate : true,
            handler(newVal)
            {
                if(newVal.facts != null)
                    this.keyFacts = newVal.facts;
            }
        }
    }
}
</script> 